import React from 'react';
import { GraduationCap, Users2, TrendingUp, Check, ArrowRight } from 'lucide-react';

const segments = [
  {
    icon: Users2,
    title: 'Teams & Enterprises',
    description:
      'Streamline workflows, align teams, and turn ideas into action with AI-powered collaboration tools.',
    features: ['Real-time collaboration', 'Workflow automation', 'Enterprise-grade security'],
  },
  {
    icon: TrendingUp,
    title: 'Small & Medium Businesses',
    description:
      'Automate repetitive tasks, create content faster, and operate more efficiently with AI built for growing companies.',
    features: ['Cost-effective pricing', 'Business automation', 'Scalable as you grow'],
  },
  {
    icon: GraduationCap,
    title: 'Educators & Institutions',
    description:
      'Save time on lesson planning, enable interactive learning, and reduce manual effort with AI designed for education.',
    features: ['AI-assisted learning', 'Lesson planning tools', 'Interactive activities'],
  },
];

export default function WhoIsItFor() {
  return (
    <section className="py-14 sm:py-20 lg:py-32 px-4 sm:px-6 lg:px-12 bg-gradient-to-b from-white via-gray-50/50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-10 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-light tracking-tight text-gray-900 mb-4 sm:mb-6">
            Who is Longfloat for?
          </h2>
          <p className="text-base sm:text-lg text-gray-600 font-light max-w-3xl mx-auto">
            Purpose-built AI for teams of all sizes from growing businesses to global enterprises.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8">
          {segments.map((segment, index) => {
            const Icon = segment.icon;

            return (
              <div
                key={index}
                className="
                  group relative bg-white rounded-lg px-6 py-8 sm:px-10 sm:py-12 lg:px-12 lg:py-16 cursor-pointer
                  border border-gray-200
                  transition-all duration-500
                "
              >

                {/* Icon */}
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-900 text-white mb-6 sm:mb-8 transition-all duration-500 group-hover:scale-105">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>

                {/* Content */}
                <h3 className="text-2xl sm:text-3xl font-light tracking-tight text-gray-900 mb-4 sm:mb-6">
                  {segment.title}
                </h3>

                <p className="text-base text-gray-600 leading-relaxed mb-5 sm:mb-6">
                  {segment.description}
                </p>

                {/* Features */}
                <ul className="space-y-3 mb-0 sm:mb-4">
                  {segment.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <Check className="w-4 h-4 mr-2 text-gray-900" strokeWidth={2} />
                      {feature}
                    </li>
                  ))}
                </ul>

              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
